module.exports = __webpack_public_path__ + "img/phone_icon.0795b842.svg";